import { AppLayoutResolverService } from './layouts/app-layout/app-layout-resolver.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService as AuthGuard } from './services/common_service/userAuthenticate.service';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    resolve: { rclcData: AppLayoutResolverService },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'wise/home/:lang',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
      },
      {
        path: 'wisechannelpartner/home/:lang',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
      },
      {
        path: 'wise/search/:lang',
        loadChildren: () => import('./pages/search-page/search-page.module').then(m => m.SearchPageModule)
      },
      {
        path: 'wisechannelpartner/search/:lang',
        loadChildren: () => import('./pages/search-page/search-page.module').then(m => m.SearchPageModule)
      },
      {
        path: 'wise/DocumentDetail/:lang',
        loadChildren: () => import('./pages/document/document.module').then(m => m.DocumentModule)
      },
      {
        path: 'wisechannelpartner/DocumentDetail/:lang',
        loadChildren: () => import('./pages/document/document.module').then(m => m.DocumentModule)
      },
      {
        path: 'wise/processes/:lang',
        loadChildren: () => import('./pages/processes-landing/processes-landing.module').then(m => m.ProcessesLandingModule)
      },
      {
        path: 'wisechannelpartner/processes/:lang',
        loadChildren: () => import('./pages/processes-landing/processes-landing.module').then(m => m.ProcessesLandingModule)
      },
      {
        path: 'wise/products/:lang',
        loadChildren: () => import('./pages/products-landing/products-landing.module').then(m => m.ProductsLandingModule)
      },
      {
        path: 'wisechannelpartner/products/:lang',
        loadChildren: () => import('./pages/products-landing/products-landing.module').then(m => m.ProductsLandingModule)
      },
      {
        path: 'wise/VideoAssetDetail/:lang',
        loadChildren: () => import('./pages/video-details/video-details.module').then(m => m.VideoDetailsModule)
      },
      {
        path: 'wisechannelpartner/VideoAssetDetail/:lang',
        loadChildren: () => import('./pages/video-details/video-details.module').then(m => m.VideoDetailsModule)
      },
      {
        path: 'wise/quickreference/:lang',
        loadChildren: () => import('./pages/quickreference-page/quickreference-page.module').then(m => m.QuickreferencePageModule)
      },
      {
        path: 'wisechannelpartner/quickreference/:lang',
        loadChildren: () => import('./pages/quickreference-page/quickreference-page.module').then(m => m.QuickreferencePageModule)
      },
      {
        path: 'wise/errorCodeLookup/:lang',
        loadChildren: () => import('./pages/error-code-lookup/error-code-lookup.module').then(m => m.ErrorCodeLookupModule)
      },
      {
        path: 'wisechannelpartner/errorCodeLookup/:lang',
        loadChildren: () => import('./pages/error-code-lookup/error-code-lookup.module').then(m => m.ErrorCodeLookupModule)
      },
      {
        path: 'wise/failureIdCodeLookup/:lang',
        loadChildren: () => import('./pages/failure-id-code-lookup/failure-id-code-lookup.module').then(m => m.FailureIdCodeLookupModule)
      },
      {
        path: 'wisechannelpartner/failureIdCodeLookup/:lang',
        loadChildren: () => import('./pages/failure-id-code-lookup/failure-id-code-lookup.module').then(m => m.FailureIdCodeLookupModule)
      },
      {
        path: 'wise/error/:lang',
        loadChildren: () => import('./pages/error-page/error-page.module').then(m => m.ErrorPageModule)
      },
      {
        path: 'wisechannelpartner/error/:lang',
        loadChildren: () => import('./pages/error-page/error-page.module').then(m => m.ErrorPageModule)
      },
      {
        path: 'wise/dynamicproducthomepage/:lang',
        loadChildren: () => import('./pages/product-details/product-details.module').then(m => m.ProductDetailsModule)
      },
      {
        path: 'wisechannelpartner/dynamicproducthomepage/:lang',
        loadChildren: () => import('./pages/product-details/product-details.module').then(m => m.ProductDetailsModule)
      },
      {
        path: 'wise/regionalsupportlink/:lang',
        loadChildren: () => import('./pages/regional-support/regional-support.module').then(m => m.RegionalSupportModule)
      },
      {
        path: 'wisechannelpartner/regionalsupportlink/:lang',
        loadChildren: () => import('./pages/regional-support/regional-support.module').then(m => m.RegionalSupportModule)
      },
      {
        path: 'wise/favorites/:lang',
        loadChildren: () => import('./pages/favorites-landing/favorites-landing.module').then(m => m.FavoritesLandingModule)
      },
      {
        path: 'wisechannelpartner/favorites/:lang',
        loadChildren: () => import('./pages/favorites-landing/favorites-landing.module').then(m => m.FavoritesLandingModule)
      },
      {
        path: 'wise/configDashboard/:lang',
        loadChildren: () => import('./pages/cms-admin/cms-admin.module').then(m => m.CmsAdminModule)
      },
      {
        path: 'wisechannelpartner/AuthorizationError/:lang',
        loadChildren: () => import('./pages/authorization-error/authorization-error.module').then(m => m.AuthorizationErrorModule)
      },
      {
        path: 'wise/launchwiseapplication', redirectTo: '/wise/home/ams-en', pathMatch: 'full'
      },
      {
        path: 'wise/logout/:lang',
        loadChildren: () => import('./pages/logout-page/logout.module').then(m => m.LogoutModule)
      },
      {
        path: '', redirectTo: '/wise/home/ams-en', pathMatch: 'full'
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
